module.exports = __webpack_public_path__ + "img/sidebar-icon-black.5dba1905.svg";